const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { redirectToLoopVisualizationOfType } from '@/features/visualizations/utils/redirectToLoopVisualizationOfType';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/')({
  loader: async ({
    params,
    context: {
      queryClient
    }
  }) => {
    await redirectToLoopVisualizationOfType({
      org: params.org,
      loopId: params.loopId,
      viewId: params.viewId,
      queryClient
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});